import React, { useEffect, useRef } from 'react';

export const MeasureRows = ({ data, columns, onMeasure, renderRowContent, defaultRowHeight }) => {
  const containerRef = useRef();
  useEffect(() => {
    if (containerRef.current) {
      const newHeights = {};
      Array.from(containerRef.current.children).forEach((child, index) => {
        const measured = child.getBoundingClientRect().height;
        // Add 10px only if it's taller than default row height
        newHeights[index] = measured > defaultRowHeight ? measured + 20 : measured+20;
      });
      onMeasure(newHeights);
    }
  }, [data]);
  return (
    <div style={{ visibility: 'hidden', position: 'absolute', top: 0, left: 0, zIndex: -1 }}>
      <div ref={containerRef}>
        {data.map((row, index) => (
          <div key={index} style={{ display: 'flex', width: '100%' }}>
            {renderRowContent(row, columns, index)}
          </div>
        ))}
      </div>
    </div>
  );
};